<template lang="pug">
  .page
    section
      .text-center
        h1 ABOUT US
    section.pt-0
      b-container
        .row
          .col-md-6.text-center
            img.w-100.mb-5(src="https://ams3.digitaloceanspaces.com/wall.res/resources/images/about-us.jpg")
          .col-md-6
            p
              | We’re a fine art marketplace with a simple objective -
              | providing an easily accessible and centralised platform,
              | connecting art collectors with both established and aspirational local artists.
            p
              | We are hugely passionate about local art and design,
              | and have dedicated years to understanding the needs of collectors and artists alike.
              | Once we turned our attention to understanding the fine arts value chain -
              | it prompted our realisation of the need for a technology led platform,
              | where customers are digitally connected with a diverse and growing collection of artists.
              | We aim to make premium art more accessible and tailored to the needs of collectors.
              | Similar to a traditional gallery, all artist applications are reviewed by our curation team
              | before being listed on the platform, thus ensuring that the browsing experience is of the highest standard.
            p
              | Our mission is to provide a best in class service to showcase the abundant creative talent that our country has to offer.
</template>

<script>
import standardMix from '@/mixins/standardMix';

export default {
  name: 'ContactUs',
  components: {
  },
  mixins: [standardMix],
  computed: {
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/About.vue